import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';
import { BaseForm } from 'projects/admin/src/app/classes/base-form';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { FormHelper } from 'projects/admin/src/app/shared/form-helper';
import { PackageModel } from 'projects/core/src/lib/models/package.model';

const SEPARATOR = ',';

@Component({
  selector: 'app-billing-basedata',
  templateUrl: './billing-basedata.component.html',
  styleUrls: ['./billing-basedata.component.scss']
})
export class BillingBasedataComponent extends BaseForm implements OnInit {

  @Input() package: PackageModel = null;
  @Output() setEdit = new EventEmitter<string>();

  public loading = false;
  public form = this.fb.group({
    number: new UntypedFormControl(''),
    name: new UntypedFormControl('', [Validators.required]),
    status: new UntypedFormControl(''),
    price: new UntypedFormControl(''),
    amount: new UntypedFormControl(''),
    used: new UntypedFormControl(''),
  });

  constructor(
    private fb: UntypedFormBuilder,
    private ui: UiService,
    private api: ApiService,
    private transloco: TranslocoService,
  ) {
    super();
  }

  ngOnInit(): void {
  }

  onSubmit(): void {
  }

  protected startEdit(): void {
    if (this.package !== null) {
      this.form.patchValue({
      });
    }
    this.setEdit.emit('basedata');
    super.startEdit();
    this.ui.setFormFocus();
  }

  protected stopEdit(): void {
    this.form.reset();
    this.setEdit.emit(null);
    super.stopEdit();
    this.ui.setFocus();
  }

}
